<micro-lookup domain="auth" obj="contacts" url="/contacts" [key]="contactId"></micro-lookup>
